import React from "react";

/**
 * 统计卡片 — 在线假人数 / 总假人数
 */
const BotStatsCards = ({ onlineCount, totalCount }) => {
  return (
    <div className="botcontrol-stats-cards">
      <div className="botcontrol-stat-card">
        <div
          className="botcontrol-stat-icon"
          style={{ background: "rgba(72, 187, 120, 0.1)" }}
        >
          <i
            className="fas fa-play-circle"
            style={{ color: "#48BB78" }}
          ></i>
        </div>
        <div className="botcontrol-stat-content">
          <div className="botcontrol-stat-value">{onlineCount}</div>
          <div className="botcontrol-stat-label">在线假人数</div>
        </div>
      </div>

      <div className="botcontrol-stat-card">
        <div
          className="botcontrol-stat-icon"
          style={{ background: "rgba(66, 153, 225, 0.1)" }}
        >
          <i className="fas fa-robot" style={{ color: "#4299E1" }}></i>
        </div>
        <div className="botcontrol-stat-content">
          <div className="botcontrol-stat-value">{totalCount}</div>
          <div className="botcontrol-stat-label">总假人数</div>
        </div>
      </div>
    </div>
  );
};

export default BotStatsCards;
